// @flow
import React from 'react';
import Box from "@material-ui/core/Box";
import { TYPE } from '../../constants/targetConstants';
import DeferRender from '../ui/DeferRender';
import TargetList from './TargetList';

export type Props = $ReadOnly<{
    cars: $ReadOnlyArray<string>
}>;

function Cars({ cars }: Props) {

    return (
        <Box p={2}>
            <DeferRender>
                <TargetList items={cars} type={TYPE.car} showSession />
            </DeferRender>
        </Box>
    );
}

export default Cars;